import cn from "classnames";
import { SubTitle2, Label } from "@components/new/Typo";
import styles from './Store.module.scss';

interface StoreProps {
  id?: string;
  name: string;
  className?: string;
  size?: 'large' | 'small';
}

function getInitials(name: string): string {
  const s = name.trim();
  const res = s
    .split(/\s+/)
    .slice(0, 2)
    .map(v => v[0])
    .join("");

  return (res.length < 2 ? name.slice(0, 2) : res).toUpperCase();
}

const getColor = (name: string) => {
  const colors = ["#8DCB56", "#6F0BC1", "#E17B98", "#D9CF37", "#1CD8BC", "#734027", "#1A68DE", "#DE1A1D"];
  const idx = name.split("")
    .reduce((acc: number, v: string) => acc + v.charCodeAt(0), 0) % colors.length;
  return colors[idx];
};

export const Store: React.FC<StoreProps> = ({
  id,
  name,
  className,
  size,
}) => {
  const initials = getInitials(name || "");

  const Text = size === "small" ? Label : SubTitle2;

  return (
    <div
      className={cn(
        className,
        styles.store,
        size === "small" && styles.small,
      )}
      style={{ backgroundColor: getColor(id || name || "") }}
    >
      <Text>{initials}</Text>
    </div>
  );
};
